import cn from 'classnames'
import { isValidString } from 'mmfintech-commons'
import type { ReactNode } from 'react'

type EntityFieldRowProps = {
  label: ReactNode
  value: ReactNode
  trailing?: ReactNode
  dataTest?: string
  className?: string
}

export const EntityFieldRow = ({ label, value, trailing, dataTest, className }: EntityFieldRowProps) => {
  if (value === null || value === undefined) return null
  if (typeof value === 'string' && !isValidString(value)) return null

  return (
    <div className={cn('entity-field-row', className)}>
      <div className='entity-field-row-text'>
        <div className='entity-field-row-label'>{label}</div>
        <div className='entity-field-row-value' data-test={dataTest}>
          {value}
        </div>
      </div>
      {trailing && <div className='entity-field-row-trailing'>{trailing}</div>}
    </div>
  )
}
